





























































import Proxyable from '@/mixins/proxyable';
import { PropValidator } from 'vue/types/options';
import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from './ErrorAlert.vue';

export default Proxyable.extend({
  name: 'ConfirmationDialog',

  components: { ALDialog, ErrorAlert },

  props: {
    errorMessages: {
      type: [String, Array],
      default: () => ''
    } as PropValidator<string | string[]>,
    detailErrorMessages: {
      type: [String, Array],
      default: () => ''
    } as PropValidator<string | string[]>,
    title: String,
    message: String,
    persistent: Boolean,
    loading: Boolean,
    width: {
      type: [Number, String],
      default: 450
    },
    hideHeader: Boolean
  },

  computed: {
    isActionsSlotProvided(): boolean {
      return !!this.$scopedSlots.actions;
    },

    internalErrorMessages(): string[] {
      return this.genInternalMessages(this.errorMessages);
    }
  },

  mounted() {
    if (!this.isActionsSlotProvided) {
      console.warn(
        `${this.$options.name}: No actions slot provided, use scoped slot named 'actions'`
      );
    }
  },

  methods: {
    clearAllErrors() {
      this.$emit('clearErrors');
    },

    close() {
      this.$emit('close');
      this.internalValue = false;
    },

    genInternalMessages(messages: string | string[]): string[] {
      // is case message is an empty string
      if (!messages) return [];
      else if (Array.isArray(messages)) return messages;
      else return [messages];
    }
  }
});
